import { useSurveyResponsesQuery } from '@hotjar/feedback/domain/Surveys/query';
import type { SurveyResponsesDto } from '@hotjar/feedback/domain/Surveys/Responses/SurveyResponseDto';
import { useEffect, useState } from 'react';
import type { Clause } from '@hotjar/feedback/domain/Surveys/Responses/Filters/Clause';

export const useLoadResponses = (
  siteId: number | undefined,
  surveyId: number | undefined,
  sort: string,
  filters: Clause[],
  pageNumber: number,
  pageSize: number,
): SurveyResponsesDto | undefined => {
  const { data: responsesData, isPreviousData } = useSurveyResponsesQuery(
    siteId,
    surveyId,
    sort,
    filters ?? [],
    pageNumber,
    pageSize,
  );

  // While changing site/survey, do not reuse the responses data
  const [shouldUsePreviousData, setShouldUsePreviousData] = useState(false);
  useEffect(() => {
    setShouldUsePreviousData(false);
  }, [siteId, surveyId]);

  // after fresh data is loaded, we can resume using previous data until the site/survey changes again
  useEffect(() => {
    if (!shouldUsePreviousData && !isPreviousData) {
      setShouldUsePreviousData(true);
    }
  }, [shouldUsePreviousData, isPreviousData]);

  return isPreviousData && !shouldUsePreviousData ? undefined : responsesData;
};
